export default __webpack_public_path__ + "static/media/cars-parked-apartment-building.eac00c2b.jpg";